import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgWeather = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#00C5F2"
      fillRule="evenodd"
      d="M15 5c4.197 0 7.79 2.586 9.273 6.25h3.853A6.874 6.874 0 0 1 35 18.124v.002A6.874 6.874 0 0 1 28.126 25H15C9.477 25 5 20.523 5 15S9.477 5 15 5"
      clipRule="evenodd"
    />
    <path
      fill="#85E3F9"
      fillRule="evenodd"
      d="M26 33a2 2 0 0 0 2-2q0-1.105-2-4-2 2.895-2 4a2 2 0 0 0 2 2M20 33a2 2 0 0 0 2-2q0-1.105-2-4-2 2.895-2 4a2 2 0 0 0 2 2M14 33a2 2 0 0 0 2-2q0-1.105-2-4-2 2.895-2 4a2 2 0 0 0 2 2"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      d="M15 23.5v-1h15a5.5 5.5 0 0 0 5.5-5.5v-1h1v1a6.5 6.5 0 0 1-6.5 6.5z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgWeather);

export default ForwardRef;
